import { render } from "./ProjectName.vue?vue&type=template&id=6c65fbb4"
import script from "./ProjectName.vue?vue&type=script&lang=js"
export * from "./ProjectName.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__